import React from "react";
import { StyledTable, Li, ListItem } from "./Components";
import { Typography } from "@material-ui/core";
import dem_haz_lev from "../img/sswpIcons/DemolitionMethod/dem_haz_lev.png";
import dem_bur from "../img/sswpIcons/DemolitionMethod/dem_bur.png";
import dem_by_han from "../img/sswpIcons/DemolitionMethod/dem_by_han.png";
import dem_che_age from "../img/sswpIcons/DemolitionMethod/dem_che_age.png";
import dem_cra from "../img/sswpIcons/DemolitionMethod/dem_cra.png";
import dem_de_gas from "../img/sswpIcons/DemolitionMethod/dem_de_gas.png";
import dem_dri_saw from "../img/sswpIcons/DemolitionMethod/dem_dri_saw.png";
import dem_env_ris_ass from "../img/sswpIcons/DemolitionMethod/dem_env_ris_ass.png";
import dem_exp from "../img/sswpIcons/DemolitionMethod/dem_exp.png";
import dem_fac_ret_sho from "../img/sswpIcons/DemolitionMethod/dem_fac_ret_sho.png";
import dem_fir_gas_vap from "../img/sswpIcons/DemolitionMethod/dem_fir_gas_vap.png";
import dem_flo_con from "../img/sswpIcons/DemolitionMethod/dem_flo_con.png";
import dem_for_wor from "../img/sswpIcons/DemolitionMethod/dem_for_wor.png";
import dem_gra from "../img/sswpIcons/DemolitionMethod/dem_gra.png";
import dem_hot_cut from "../img/sswpIcons/DemolitionMethod/dem_hot_cut.png";
import dem_imp_ham from "../img/sswpIcons/DemolitionMethod/dem_imp_ham.png";
import dem_lia_per from "../img/sswpIcons/DemolitionMethod/dem_lia_per.png";
import dem_lon_rea from "../img/sswpIcons/DemolitionMethod/dem_lon_rea.png";
import dem_mac from "../img/sswpIcons/DemolitionMethod/dem_mac.png";
import dem_met_sta from "../img/sswpIcons/DemolitionMethod/dem_met_sta.png";
import dem_pol_pus_arm from "../img/sswpIcons/DemolitionMethod/dem_pol_pus_arm.png";
import dem_pre_ste from "../img/sswpIcons/DemolitionMethod/dem_pre_ste.png";
import dem_pre_wea_pla from "../img/sswpIcons/DemolitionMethod/dem_pre_wea_pla.png";
import dem_pro from "../img/sswpIcons/DemolitionMethod/dem_pro.png";
import dem_pub_exc_zon from "../img/sswpIcons/DemolitionMethod/dem_pub_exc_zon.png";
import dem_rem_con from "../img/sswpIcons/DemolitionMethod/dem_rem_con.png";
import dem_rop_dem from "../img/sswpIcons/DemolitionMethod/dem_rop_dem.png";
import dem_she_pul from "../img/sswpIcons/DemolitionMethod/dem_she_pul.png";
import dem_sit_spe_met from "../img/sswpIcons/DemolitionMethod/dem_sit_spe_met.png";
import dem_str_sur from "../img/sswpIcons/DemolitionMethod/dem_str_sur.png";
import dem_the_lan from "../img/sswpIcons/DemolitionMethod/dem_the_lan.png";
import dem_vib_con from "../img/sswpIcons/DemolitionMethod/dem_vib_con.png";
import dem_wre_bal from "../img/sswpIcons/DemolitionMethod/dem_wre_bal.png";
import dem_eme_pro from "../img/sswpIcons/DemolitionMethod/dem_eme_pro.png";

export default {
    icon: dem_haz_lev,
    name: "Demolition Method",
    text: "",
    icons: {
        dem_str_sur: {
            name: "Structural Survey",
            icon: dem_str_sur,
            text: (
                <ul>
                    <ListItem text="Identify parts of the structure that are carrying loads in addition to their own weight." />
                    <ListItem text="Develop a safe plan of operation that will only remove these parts after the additional load has been removed to prevent an unplanned collapse." />
                </ul>
            )
        },
        dem_env_ris_ass: {
            name: "Environmental Risk Assessment",
            icon: dem_env_ris_ass,
            text: (
                <ul>
                    <ListItem text="This must be carried out in the event of any rainwater, water, or sewerage being removed from an excavation or similar." />
                    <ListItem text="Untreated or contaminated material must not re-enter the ground water." />
                    <ListItem text="If required separate storage of adequate volume must be provided." />
                </ul>
            )
        },
        dem_met_sta: {
            name: "Method Statement",
            icon: dem_met_sta,
            text: (
                <ul>
                    <ListItem text="Where a detailed method statement has been provided, all operatives involved in the task must be brought through it in a manner they can understand." />
                    <Li>
                        <Typography variant="title">
                            The Method Statement should consist of
                        </Typography>
                        <ol>
                            <ListItem text="Scope (timings, locations, visibility, volumes etc)" />
                            <ListItem text="Working drawings/ Plans" />
                            <ListItem text="Step by step instructions/ work methods" />
                            <ListItem text="Hazards present and controls required, including PPE requirements." />
                            <ListItem text="Resources that will be used (operatives and their role on site, plant, tools and materials)" />
                            <ListItem text="Other activities that may be on site" />
                            <ListItem text="Responsible persons and their roles" />
                            <ListItem text="Contact details for site issues." />
                            <ListItem text="First Aid provisions and emergency procedures" />
                            <ListItem text="Operatives should be allowed to ask questions and clarify any steps they are unsure of." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        dem_lia_per: {
            name: "Liaison/Permission",
            icon: dem_lia_per,
            text: (
                <ul>
                    <ListItem text="If you work will affect adjoining property, you are required to liase with the relevant property owner." />
                    <ListItem text="If your work requires you to enter or make alterations to, adjoinging property then you will require permission from the relevant property owner." />
                </ul>
            )
        },
        dem_eme_pro: {
            name: "Emergency Procedures",
            icon: dem_eme_pro,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            The site should have a written emergency response
                            procedure. This will cover
                        </Typography>
                        <ol>
                            <ListItem text="Evacution" />
                            <ListItem text="Notification to emergency services" />
                            <ListItem text="Ensuring safe access routes for arriving emergency services" />
                            <ListItem text="First Aid" />
                            <ListItem text="Controlling access to area" />
                            <ListItem text="Rescue arrangements" />
                            <ListItem text="Environmental protection" />
                            <ListItem text="Fire protection and fire fighting arrangements and procedures" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        dem_flo_con: {
            name: "Flood Controls",
            icon: dem_flo_con,
            text: (
                <ul>
                    <ListItem text="Before commencing operations, the forecast conditions need to be assessed for tidal and weather effect." />
                    <Li>
                        <Typography variant="title">
                            Where a risk exists,
                        </Typography>
                        <ol>
                            <ListItem text="operations need to be postponed until after the risk has passed, or " />
                            <ListItem text="additional controls need to be identified and put in place." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        dem_de_gas: {
            name: "De-Gas/ Empty/ Clean",
            icon: dem_de_gas,
            text: (
                <ul>
                    <ListItem text="Restricted openings relative to the size of the space will adversely affect the success of/ length of time required for this operation." />
                    <ListItem text="After completing this procedure, the atmosphere needs to be tested to check that it has been effective, and that it is safe to allow people to enter without breathing apparatus." />
                    <ListItem text="Cross ventilation should be maintained (particularly at the top and bottom of the space). Ongoing mechanical ventilation of fresh clean air into the space may also be required. Do not use oxygen as it will create a fire/ explosion hazard along with being potentially toxic itself." />
                </ul>
            )
        },
        dem_fir_gas_vap: {
            name: "Fire/ Gas/ Vapour Controls",
            icon: dem_fir_gas_vap,
            text: (
                <ul>
                    <ListItem text=" Bar heaters are not to be used on site. All naked flames are to be tightly controlled" />
                    <ListItem text="No Smoking" />
                    <ListItem text="Use methods to maximise ventilation" />
                    <ListItem text="You must have a fire detection and alarm system" />
                    <ListItem text="You must have a fire escape plan, and should have an alternative route plan." />
                </ul>
            )
        },
        dem_pre_wea_pla: {
            name: "Pre Weakening Plan",
            icon: dem_pre_wea_pla,
            text: (
                <ul>
                    <ListItem text="You require a written method statement prepared by a competent person" />
                </ul>
            )
        },
        dem_for_wor: {
            name: "Form Work",
            icon: dem_for_wor,
            text: (
                <ul>
                    <ListItem text="These are used in underpinning and concrete construction" />
                    <ListItem text="They are engineered structurally and must include a documented installation method" />
                    <ListItem text="The written installation method must be followed by trained operatives when working with formwork." />
                </ul>
            )
        },
        dem_fac_ret_sho: {
            name: "Facade Retention Shoring",
            icon: dem_fac_ret_sho,
            text: (
                <ul>
                    <ListItem text="To retain the look of a building exterior during works." />
                    <ListItem text=" This must be a designed temporary support system." />
                    <ListItem text="Must be erected by a trained operative" />
                    <ListItem text="Assembly and welding work should be carried out at ground level" />
                    <ListItem text="Should have a temporary works permit system for use." />
                </ul>
            )
        },
        dem_mac: {
            name: "Machine",
            icon: dem_mac,
            text: (
                <ul>
                    <ListItem text="Plant used for demolition work must have cab protection to prevent material intrusion. The cab protection must have a regular thorough inspection by a competent person. The cab protection must be visually inspected by the driver at the beginning of each shift, and after material impact, for damage and secure attachment." />
                    <ListItem text="In general the height of the structure to be demolished cannot be greater than the reach of the piece of plant." />
                </ul>
            )
        },
        dem_cra: {
            name: "Crane",
            icon: dem_cra,
            text: (
                <ul>
                    <ListItem text="The crane must be properly and regularly maintained." />
                    <ListItem text="The crane and lifting gear must be selected to match job requirements" />
                    <ListItem text="The crane operator must be trained and have a CSCS card (for tower cranes). The operation must be directed by a CSCS Slinger Signaller. The crane operator must have direct view of the load or signaller when undertaking lifting operations." />
                    <ListItem text="The operator must follow the manufacturers operating procedures. This manual must be available on site for the operator to reference." />
                    <ListItem text="The crane must be placed on firm, level ground with sufficient bearing capacity" />
                    <ListItem text="Special care, and additional controls, will be required when working in the vicinity of overhead lines." />
                    <ListItem text="Wind speeds must be below that specified by the manufacturer for the operation being undertaken" />
                    <ListItem text=" The path of the load must be planned to prevent swinging loads passing over site operatives. Operatives not involved with the load must remain outside of the fall zone." />
                </ul>
            )
        },
        dem_by_han: {
            name: "By Hand",
            icon: dem_by_han,
            text: (
                <ul>
                    <ListItem text="Hand Held tools are used when there is a higher risk posed by using mechanical devices" />
                    <ListItem text="Take care that debris generated does not create a hazard" />
                    <ListItem text="Dig with extra care around services. Do NOT use picks or other impact tools." />
                </ul>
            )
        },
        dem_dri_saw: {
            name: "Drilling/ Sawing",
            icon: dem_dri_saw,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            The appropriate method must be selected based upon
                        </Typography>
                        <ol>
                            <ListItem text="Tool capability" />
                            <ListItem text="Accuracy requirements" />
                            <ListItem text="Acceptability of noise, dust, smoke or vibration" />
                            <ListItem text="Task requirements, environment and space availability" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        dem_imp_ham: {
            name: "Impact Hammer",
            icon: dem_imp_ham,
            text: (
                <ul>
                    <ListItem text="The tool and attachments need to be inspected by a competent person before use, for condition and secure fit and proper attachment of pins and pipes." />
                    <ListItem text="The area around the works needs to be regularly monitored to ensure unplanned loose material or a deterioration in the surroundings to not present a hazard." />
                    <ListItem text="No persons are permitted within 20m of the hammer while operating." />
                    <ListItem text="The tool must be maintained and cleaned in accordance with, and as scheduled in the manufacturer’s instructions." />
                    <ListItem text="The hammer is NOT to be run for more than 15 seconds on the same spot." />
                    <ListItem text="The operator must be wearing ear protection" />
                </ul>
            )
        },
        dem_lon_rea: {
            name: "Long Reach",
            icon: dem_lon_rea,
            text: (
                <ul>
                    <ListItem text="The machine must be used in the correct position relative to the work face and the angle of the boom must be in accordance with the manufacturer’s instructions." />
                    <ListItem text="The ground around the machine must be level, stable, have sufficient load bearing and kept clear." />
                </ul>
            )
        },
        dem_pol_pus_arm: {
            name: "Demolition Pole/ Pusher Arm",
            icon: dem_pol_pus_arm,
            text: (
                <ul>
                    <ListItem text="The equipment must be properly and regularly maintained" />
                    <ListItem text="Prior to each use it must be visually inspected for defects and correct fitting" />
                    <ListItem text="The equipment must be used in accordance with the manufacturer’s instructions. Demolition work must be progressed in controlled stages." />
                    <ListItem text="All other operatives must be excluded from the potential fall zone." />
                </ul>
            )
        },
        dem_gra: {
            name: "Grapple",
            icon: dem_gra,
            text: (
                <ul>
                    <ListItem text="Prior to use, the machine must be inspected by a competent person to ensure all attachments are fitted correctly, are secure, and free from defects." />
                </ul>
            )
        },
        dem_she_pul: {
            name: "Shears/ Pulverizer",
            icon: dem_she_pul,
            text: (
                <ul>
                    <ListItem text="Hydraulic shears should only be used when cutting and severing material at ground level." />
                    <ListItem text="Prior to use, the machine assembly must be inspected by a competent person for defects and fit for use." />
                </ul>
            )
        },
        dem_wre_bal: {
            name: "Wrecking Ball",
            icon: dem_wre_bal,
            text: (
                <ul>
                    <ListItem text="This should be fitted to the plant using a lattice jib" />
                    <ListItem text="The method of work must prevent the ball from getting trapped, causing the crane to be overloaded by pulling etc" />
                    <ListItem text="The assembly must be inspected by a competent person prior to use" />
                </ul>
            )
        },
        dem_che_age: {
            name: "Chemical Agents",
            icon: dem_che_age,
            text: (
                <ul>
                    <ListItem text="Operatives must be fully trained in the agents use" />
                    <ListItem text="There must be a site specific methodology written down and the operative taken through it’s contents" />
                    <ListItem text="The operative must follow the safety data sheet for the agent involved." />
                </ul>
            )
        },
        dem_bur: {
            name: "Bursting",
            icon: dem_bur,
            text: (
                <ul>
                    <ListItem text="Ensure you have read and follow the Safety Data Sheet of the bursting agent you are using" />
                </ul>
            )
        },
        dem_hot_cut: {
            name: "Hot Cutting",
            icon: dem_hot_cut,
            text: (
                <ul>
                    <ListItem text="This work can only take place in environments without risk of fire or explosion." />
                    <ListItem text="There should be a permit to work system in place (with designated personnel and timings) " />
                    <ListItem text="There must be adequate ventilation/ fume extraction." />
                    <ListItem text="The material to be cut should be inspected for flammable contaminants, and if required thoroughly cleaned." />
                    <ListItem text="There must be a Carbon Dioxide or Dry Powder Extinguisher present." />
                    <ListItem text="The correctly rated PPE must be worn, including; eye protection/ face protection; mask; gloves; safety boots; close-fitting and flame retardant overalls." />
                </ul>
            )
        },
        dem_the_lan: {
            name: "Thermic Lancing",
            icon: dem_the_lan,
            text: (
                <ul>
                    <ListItem text="This produces molten material and thick smoke" />
                    <ListItem text="Operators need to be trained in the operation" />
                    <ListItem text="The area must be cleared of other workers, and well ventilated" />
                    <ListItem text="You should have, and must follow a SDS sheet for the lance you are using." />
                    <ListItem text="Generally sand is used to control/contain molten material" />
                    <ListItem text="Ensure you have sufficient supply of the lance tubes" />
                    <ListItem text="Check the condition of the tube holder, hand valve and oxygen regulator, and flash-back arrestor before use." />
                    <ListItem text="You should have a direct oxygen supply, or a minimum of 3 x 2500-3000 psi oxygen cylinders. The oxygen supply/cylinders need to be protected from heat, sparks, and the generated slag. Ensure your oxygen/safety hoses are of suitable length, is a high pressure hose, and fittings are secure and in good condition" />
                    <Li>
                        <Typography variant="title">
                            General Procedure, as guidance only (follow
                            training)
                        </Typography>
                        <ol>
                            <ListItem text="Start by ensuring oxygen source is shut off" />
                            <ListItem text="Check lance ends to ensure they are free of dirt or other obstructions" />
                            <ListItem text="Check lance holder is free of dirt, oil, grease. If you suspect damage, DO NOT USE" />
                            <ListItem text="Check lance holder valve opens and closes freely" />
                            <ListItem text="Check lance holder valve is now in closed position" />
                            <ListItem text="Connect all parts and turn oxygen on at source (holder valve in closed position)" />
                            <ListItem text="Check all hoses, fittings and handle connections for leaks prior to use" />
                            <ListItem text="Ensure there are no kinks in the oxygen hose" />
                            <ListItem text="Set oxygen to desired operating pressure. DO NOT exceed maximum pressure." />
                            <ListItem text="Ensure lance pipe is pointed towards work site" />
                            <ListItem text="Ensure oxygen flow be opening holder valve and then closing once confirmed" />
                            <ListItem text="Ensure personnel are wearing the required PPE." />
                            <ListItem text="Heat the tip of the lance until outer pipe and/or wire rods are “cherry” red" />
                            <ListItem text="Slowly open the holder valve until completely opened. If the lance tip is properly heated, the end will light up and be ready for cutting. If this does not occur repeat the previous step." />
                            <ListItem text="Make any necessary adjustments to oxygen flow and begin to cut." />
                            <ListItem text="The lance is extinguished by closing the oxygen control valve." />
                            <ListItem text="The rate of cutting will depend on the material. Rapid oxidation materials will cut faster than cast iron or concrete. If cutting non ferrous, concrete or  refractory material, the method is to melt the material, and then blow the molten material out of the kerf with oxygen pressure." />
                            <ListItem text="If a new lance is required, turn off the oxygen, and relight as above." />
                            <ListItem text="On completion turn off the oxygen at source, disconnect hoses, and return to storage ensuring equipment is safe from damage." />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            You need the following PPE, as a minimum
                        </Typography>
                        <ol>
                            <ListItem text="Extreme heat resistant PPE, normally made from aluminizing heat resistant fabrics in a suitable weight, including a steel makers suit and apron to protect against the radiant heat" />
                            <ListItem text="Fire retardant full head and face mask/hood" />
                            <ListItem text="Thick fire retardant mittens/gloves" />
                            <ListItem text="Fire retardant safety boots AND boot protector/linings" />
                            <ListItem text="Heavy duty respirator" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        dem_rop_dem: {
            name: "Rope Demolition",
            icon: dem_rop_dem,
            text: (
                <ul>
                    <ListItem text="This is where steel rope is used to pull pre-weakened parts of the structure to the ground in conjunction with a winch or plant." />
                    <ListItem text="This will require a detailed risk assessment by a competent person prior to commencing." />
                    <ListItem text="It should not be used for brick or masonry structures." />
                    <ListItem text="The ropes must have sufficient length, girth and strength for the purpose." />
                    <ListItem text="Damaged ropes must not be used." />
                    <ListItem text="The pulling operator must be protected from rope breakage and/or falling material." />
                </ul>
            )
        },
        dem_pre_ste: {
            name: "Pre Stressed Steel",
            icon: dem_pre_ste,
            text: (
                <ul>
                    <ListItem text="You require a written method statement prepared by a competent engineer." />

                    <Li>
                        <Typography variant="title">
                            The method statement will cover
                        </Typography>
                        <ol>
                            <ListItem text="The sequence of works" />
                            <ListItem text="The requirement for supports and propping during each stage of the sequence" />
                            <ListItem text="The method to be used to demolish each pre-stressed element" />
                        </ol>
                    </Li>
                    <ListItem text="All pre-stressed elements must be clearly marked on site, along with the demolition method to used" />
                    <ListItem text="You must be trained and competent with the demolition method to be used" />
                </ul>
            )
        },
        dem_exp: {
            name: "Explosives",
            icon: dem_exp,
            text: (
                <ul>
                    <ListItem text="This is a high risk activity requiring fully trained professionals with documented site specific controls." />
                </ul>
            )
        },
        dem_pub_exc_zon: {
            name: "Public Exclusion Zone",
            icon: dem_pub_exc_zon,
            text: (
                <ul>
                    <ListItem text="Use pedestrian barriers or herrace type fencing to exclude members of the public from the works area (including risk area where material could fall)" />
                    <ListItem text="Take into account weather, including wind direction, when calculating the required zone." />
                </ul>
            )
        },
        dem_pro: {
            name: "Propping",
            icon: dem_pro,
            text: (
                <ul>
                    <ListItem text="Propping may be needed even in shallow trenches (<1.25m), particularly if ground conditions are particularly poor or the nature of the work requires workers to lie or crouch in the trench." />
                    <ListItem text="Propping with soldier sets is a simple form of trench support set which can be formed with steel or timber. This system is mostly used in rock, stiff clays and in other soil types with similar self-supporting properties. " />
                    <ListItem text="Unlike shoring, soldier sets retain the earth where there may be a fault in the embankment. Soldier sets only provide ground support at regular intervals and do not provide positive ground support to the whole excavated face. Open soldier sets are only suitable for use in stable soil types." />
                    <Li>
                        <Typography variant="title">
                            The following guidelines should be followed
                        </Typography>
                        <ol>
                            <ListItem text="Keep spoil at least 600mm from edge" />
                            <ListItem text="Soldiers (vertical side element) should protrude at least 500mm above top of trench" />
                            <ListItem text="Top Tom (cross-support) should be no lower than 300mm from trench top" />
                            <ListItem text="Maximum spacing between Toms no more than 750mm" />
                            <ListItem text="All jointing should be secured with nails/screws" />
                            <ListItem text="Maximum spacing between Soldiers 1.5m" />
                            <ListItem text="Minimum size of Soldier 150x38mm" />
                            <ListItem text="Minimum size of Tom 150x38mm" />
                            <ListItem text="Tom needs to be long enough to force Soldier firmly against trench side" />
                            <ListItem text="Space between bottom Tom and trench floor should allow for pipe, generally not more than 1m." />
                        </ol>
                    </Li>
                    <ListItem text="Propping can be adaptable, particularly when working around existing services and can be quick to install especially in shallow excavations." />
                    <ListItem text="It requires considerable experience and skill to install, with each arrangement requiring bespoke design." />
                </ul>
            )
        },
        dem_vib_con: {
            name: "Vibration Controls/ Service Duration",
            icon: dem_vib_con,
            text: (
                <ul>
                    <ListItem text="These controls are applicable when operatives are using any vibrating tools, equipment or plant. The main risk is to health from long term exposure." />
                    <ListItem text="Any handles, or vibration damping attachments provided must be used by operatives" />
                    <ListItem text="Adjust any seat so that you are comfortable and it supports your lower back and so you can see clearly/operate without having to stretch, twist or lean. Avoid bad posture (slumping in your seat), constantly leaning forward or sideways. Take regular breaks, don’t jump off the machine (unless contact with electricity)" />
                    <Li>
                        <Typography variant="title">
                            For guidance only, maximum operation times/ day
                            should be limited to
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Tool</th>
                                    <th>Typical Tool</th>
                                    <th>Modern Tool</th>
                                </tr>
                                <tr>
                                    <td>Road Breaker</td>
                                    <td>1 hour 23 min (12 m/s2)</td>
                                    <td>8 hours (5 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Demolition Hammer</td>
                                    <td>0 hour 53 min (15 m/s2) </td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Hammer Drill</td>
                                    <td>2 hour 28 min (9 m/s2)</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Scabbler (hammer)</td>
                                    <td>0 hour 13 min (30 m/s2)</td>
                                    <td />
                                </tr>
                                <tr>
                                    <td>Angle Grinder (large)</td>
                                    <td>12 hour 30 min (4 m/s2)</td>
                                    <td>12 hour 30 min (4 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Sander</td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Chainsaw</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Brushcutter</td>
                                    <td>2 hour 28 min (9 m/s2)</td>
                                    <td>8 hours (5 m/s2)</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Vibrating Roller (seat adequately damped): 8 hours" />
                </ul>
            )
        },
        dem_rem_con: {
            name: "Remote Control",
            icon: dem_rem_con,
            text: (
                <ul>
                    <ListItem text="The remote control operator must always keep the transmitter key in their possession, to prevent unauthorized use. Alternatively the transmitter key must be kept in secure storage." />
                    <ListItem text="If the remote panel is belt fitted, the belt must be worn before switching on, to prevent accidental operation. It must be switched off before removing the belt." />
                    <ListItem text="The remote controlled equipment should be fitted with an automatic cut-off system in the event that signal from the remote control is lost." />
                    <ListItem text="The remote control must be maintained, and operated in accordance with the manufacturer’s instructions." />
                </ul>
            )
        },
        dem_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: dem_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
